import styled from "styled-components";

export const ChildrenWrapper = styled.div`
	min-width: 100vw;
	min-height: 100vh;
`;
